import { defaultBackground } from "../helpers/background";
import { primaryColor, textColor } from "../helpers/color";
import React from "react";
import { Helmet } from "react-helmet";
import { createGlobalStyle } from "styled-components";
const GlobalStyle = /*#__PURE__*/createGlobalStyle(["*,*::before,*::after{box-sizing:border-box;user-select:none;}html,body,#root{margin:0;height:100%;overflow:hidden;overscroll-behavior:none;}body{", " color:", ";font-family:\"Inter\",sans-serif !important;font-size:14px;font-weight:400;line-height:1.5;}#root{padding:1vh;-webkit-tap-highlight-color:rgba(0,0,0,0);}a{color:", "}"], defaultBackground, textColor, primaryColor);
export default (() => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
  rel: "stylesheet",
  type: "text/css",
  href: "https://rsms.me/inter/inter.css"
})), /*#__PURE__*/React.createElement(GlobalStyle, null)));
//# sourceMappingURL=GlobalStyle.js.map